import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { withRouter } from 'react-router';

import { URLS } from 'config';
import Avatar from 'components/Avatar';

import { containerActions } from '../Menu/actions';

import './styles.scss';
import logo from './images/logo.svg';

const visibleUrls = [
  URLS.PROFILE,
  URLS.BASE,
  URLS.PROFILECARS,
  URLS.GENDER,
  URLS.WORKING,
  URLS.EXPERIENCE,
  URLS.MOUNTHLY,
  URLS.CONFIRMATION,
  URLS.UPLOAD,
  URLS.DOWNPAYMENTS,
  URLS.BIRTHDAY
];
const visibleMenu = [URLS.PROFILE, URLS.BASE, URLS.PROFILECARS];
const hideLoginUrls = [URLS.BASE];
const Navbar = ({
  opened, menuToggle, history, user, location, backHandl
}) => {
  const checkButtonVisible = () => {
    const idx = visibleUrls.findIndex(_url => _url === location.pathname);

    return idx > -1;
  };

  const checkLoginButtonVisible = () => {
    const idx = hideLoginUrls.findIndex(_url => _url === location.pathname);

    return idx > -1;
  };
  const checkMenuButtonVisible = () => {
    const idx = visibleMenu.findIndex(_url => _url === location.pathname);

    return idx > -1;
  };


  const renderButtons = () => Object.keys(user).length ?
    <Avatar
      clickHandl={(e) => {
       e.preventDefault();
       if (opened) {
         menuToggle();
       }
       history.push(URLS.PROFILE);
     }}
    />
    : (
      checkLoginButtonVisible() === -1 &&
      (
      <button
        className="navbar-button navbar-button__blue"
        onClick={(e) => {
        e.preventDefault();
        if (opened) {
          menuToggle();
        }
        history.push(URLS.LOGIN);
        }}
      >
        <i className="icon-login --icons" />
      </button>
      ),
      checkLoginButtonVisible() !== -1 && (<div className="avatar" />)
    );

  return (
    <nav className="navbar">
      {
        checkMenuButtonVisible() ?
          <button className="navbar-button" onClick={menuToggle}>
            { !opened
              ? <i className="icon-menu --icons" />
              : <i className="material-icons">close</i>
        }
          </button> :
          <button onClick={backHandl} className="header-back">
            <Icon type="left" style={{ fontSize: 20, color: '#004475' }} />
          </button>
      }
      <div className="navbar-logo">
        <img src={logo} alt="logo" className="logo-image" />
      </div>
      {checkButtonVisible() ? renderButtons() : <div className="avatar" />}
    </nav>
  );
};

Navbar.propTypes = {
  opened: PropTypes.bool.isRequired,
  menuToggle: PropTypes.func.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  backHandl: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  opened: state.menu.opened,
  user: state.user.user
});

export default withRouter(connect(mapStateToProps, containerActions)(Navbar));



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js